import { TransactionalBehavior } from "./TransactionalBehavior";
export default TransactionalBehavior;
